import React, { Component } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Constant from "../../Constant";
import BarLoader from "react-bar-loader";

export default class Categories extends Component {
  state = {
    loading: true,
    data: [],
    columns: [
      {
        name: "Name",
        selector: "name",
        sortable: true,
      },
      {
        name: "Date",
        selector: "createdAt",
        sortable: true,
        right: true,
      },
      {
        name: "Options",
        selector: "year",
        sortable: true,
        right: true,
        cell: (row) => (
          <div className="d-flex">
            <i
              class="btn btn-light shadow-sm mx-1 fas fa-times text-danger"
              id={row.id}
              onClick={this.deleteCategory}
            ></i>
            <Link to={`/admin/category/${row.id}`}>
              <i
                class="btn btn-light shadow-sm mx-1 fas fa-pencil-alt text-dark"
                id={row.id}
              ></i>
            </Link>
          </div>
        ),
      },
    ],
  };

  componentDidMount() {
    this.getCategories();
  }
  getCategories = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/category/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        for (let i = 0; i < data.length; i++) {
          console.log(data[i]);
          var str = data[i].createdAt;
          var date = new Date(str);
          data[i].createdAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
          }-${date.getUTCFullYear()}`;
        }
        this.setState({ data: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  deleteCategory = (e) => {
    var categoryId = e.target.id;

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("categoryId", categoryId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/category/delete", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        document.location.reload();
      })
      .catch((error) => console.log("error", error));
  };

  render() {
    return (
      <div className="py-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /<b> Categories</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                <Link
                  to="/admin/add-category"
                  className="btn btn-dark float-right"
                >
                  Add Category
                </Link>
              </div>
            </div>
          </div>

          <div className="users-container p-2">
            {this.state.loading == true ? (
              <div className="container p-5">
                <div className="col-md-3 mx-auto">
                  <BarLoader color="#33cabb" height="4" />
                </div>
              </div>
            ) : (
              <DataTable
                noHeader={true}
                columns={this.state.columns}
                data={this.state.data}
                theme="solarized"
                pagination={true}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
